import { motion } from 'framer-motion';

export const AnimatedCard = ({children, isLayout = true, props}) => {
	return (
		<motion.div 
				layout={isLayout}
				{...props}
				transition={{
					duration: .4,
					ease: [1, 0, 0, 1],
				}}
				initial={{
					y: -150,
					x: 0,
					opacity: 0,
				}} 
				animate={{
					y: 0,
					x: 0,
					opacity: 1,
				}}
				exit={{
					y: 150,
					opacity: 0,
				}} >
			{children}
		</motion.div>
	)
}
